/** In-app notifications (topbar bell). Real /api/v1/notifications. */
import { apiClient } from "./client";

export interface AppNotification {
  id: string;
  kind: "INFO" | "SUCCESS" | "WARNING" | "REMINDER";
  title: string;
  body: string | null;
  link: string | null;
  readAt: string | null;
  createdAt: string;
}

export const notificationsApi = {
  list(limit = 20): Promise<AppNotification[]> {
    return apiClient
      .get<AppNotification[]>("/v1/notifications", { params: { limit } })
      .then((r) => r.data);
  },
  unreadCount(): Promise<number> {
    return apiClient
      .get<{ count: number }>("/v1/notifications/unread-count")
      .then((r) => r.data.count);
  },
  markRead(id: string): Promise<void> {
    return apiClient.post(`/v1/notifications/${id}/read`).then(() => undefined);
  },
  markAllRead(): Promise<void> {
    return apiClient.post("/v1/notifications/read-all").then(() => undefined);
  },
};

export const notificationQueryKeys = {
  unread: () => ["notifications", "unread"] as const,
  list: () => ["notifications", "list"] as const,
};
